import { getFormattedDateTime } from "components/helpers/DateTimeHelpers";
import { isArrayEmpty, isBoolean, isBooleanNullOrEmpty, isNullOrEmpty, isObjectNull } from "components/helpers/ObjectHelpers";
import Moment from 'moment';

export class PropertyManager {

    constructor(properties) {
        this.props = properties;
    }

    get hasProperties() {
        return !isArrayEmpty(this.props);
    }

    get properties() {
        return this.props;
    }

    setBoolean(systemName, val) {
        if (isArrayEmpty(this.props)) return;

        const property = this.props.find(p => p.systemName === systemName);
        if (isObjectNull(property)) return;

        if (isBoolean(property.value)) {
            property.value = val;
        } else {
            property.value = isBooleanNullOrEmpty(val) ? '' : (val ? 'True' : 'False');
        }
    }

    set(systemName, val) {
        if (isArrayEmpty(this.props)) return;

        const property = this.props.find(p => p.systemName === systemName);
        if (isObjectNull(property)) return;

        property.value = val;
    }

    get(systemName) {
        if (isArrayEmpty(this.props)) return null;

        const array = this.props.filter(x => x.hasOwnProperty("systemName"));
        if (isArrayEmpty(array)) return null;

        const obj = array.find(x => x.systemName.toUpperCase() === systemName.toUpperCase());
        if (isNullOrEmpty(obj)) return null;

        return obj.value;
    }

    getBoolean(systemName) {
        const value = this.get(systemName);

        if (isNullOrEmpty(value)) return value;
        if (isBoolean(value)) return value;

        const result = value.toLowerCase();
        if (result === "true") return true;
        return false;
    }

    getDateAndAge(systemName) {
        const value = this.get(systemName);
        if (isNullOrEmpty(value)) return "";

        try {
            const date = Moment(value);
            if (!date.isValid()) return "";

            const duration = Moment.duration(Moment().diff(date));
            return `${date.format("DD.MM.yyyy")} (${Math.floor(duration.asYears())} år)`;

        } catch {
            return "";
        }
    }

    getDate(systemName) {
        const value = this.get(systemName);
        if (isNullOrEmpty(value)) return "";

        try {
            const date = Moment(value);
            if (!date.isValid()) return "";
            return date.format("DD.MM.yyyy HH:mm");

        } catch {
            return "";
        }
    }

    getFormattedDateTime(systemName) {
        const value = this.get(systemName);
        if (isNullOrEmpty(value)) return "";

        try {
            const date = Moment(value);
            if (!date.isValid()) return "";
            return getFormattedDateTime(date);

        } catch {
            return "";
        }
    }

    getValidText(systemName) {
        const val = this.get(systemName);

        return (val === true || val === 'True') ? "Gyldig" : "Ikke gyldig";
    }

    getWithSystemName(systemName) {
        return {
            value: this.get(systemName),
            systemName
        };
    }

    getBooleanWithSystemName(systemName) {
        return {
            value: this.getBoolean(systemName),
            systemName
        };
    }

    getDateAndAgeWithSystemName(systemName) {
        return {
            value: this.getDateAndAge(systemName),
            systemName
        };
    }
}
